<template>
  <div class="slide-content">
    <div class="resize-body">
      <div class="resize-content" :style="`transform: translate(-50%,-50%) scale(${scaling})`">
        <div class="title-content">
          <img src="../../../assets/image/kjqg/index/kcjs/kcjs-title.png" class="zcqd-title" alt="">
        </div>
        <div class="kcjs-info">
          <div class="kcjs-cover" @click="toMoreList(0)">

          </div>
          <div class="kcjs-swiper">
            <div class="dggx-title"></div>
            <swiper :options="kcjsSwiper" v-if="gxList.length > 0">
              <swiperSlide v-for="(item,ind) in gxList" :key="ind">
                <div class="kcjs-item" @click="showVideo(item)">
                  <div class="item-cover">
                    <div :style="{ backgroundImage: item.cover ? `url(${item.cover})` : '',}"></div>
                  </div>
                  <div class="item-info">
                    <div class="info-title">{{item.title}}</div>
                    <div class="info-text" @wheel="textWheel">{{item.abstract}}</div>
                  </div>
                </div>
              </swiperSlide>

            </swiper>
            <div class="swiper-button-next kcjs"></div>
            <div class="swiper-button-prev kcjs"></div>
            <div class="swiper-pagination kcjs"></div>
          </div>
        </div>
        <div class="more" @click="toMoreList(1)">查看更多</div>
      </div>
    </div>
    <videoModal :videoShow="videoShow" :videoInfo="videoInfo" :videoTitle="videoInfo.title" @closeModal="videoShow = false"></videoModal>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import videoModal from "./video-modal.vue";
import services from "../../../assets/js/services";
import { mapActions } from "vuex";

export default {
  props: ["scaling"],
  mounted() {
    this.getgxList()
    
    
  },
  components: {
    swiper,
    swiperSlide,
    videoModal
  },
  data() {
    return {
      specialId: services.KJQG_SPECIAL_ID,
      school_code: localStorage.getItem("schoolCode"),
      kcjsSwiper: {
        slidesPerView: 3,
        spaceBetween: 26,
        slidesPerGroup: 3,
        navigation: {
          // 前进后退按钮 ,不同版本配置方式不同
          nextEl: `.swiper-button-next.kcjs`,
          prevEl: `.swiper-button-prev.kcjs`,
        },
        pagination: {
          el: `.swiper-pagination.kcjs`,
        },
      },
      gxList: [],
      videoShow: false,
      videoInfo: {}
    }
  },
  methods: {
    ...mapActions(["goAppsDetailsBeforeLogin"]),
    async getgxList() {
      let res = await services.getAreaSzztkLists({
        page: 1,
        length: 12,
        count: 0,
        school_code: this.school_code,
        special_id: this.specialId,
        kind: "1",
        is_video: 1,
        column_name: "大国功勋",
        order_by: "asc"
      })
      if (res.code == "0000" && res.data.items) {
        this.gxList = res.data.items
      }
    },
    showVideo(item) {
      if (item.tencent_vod_file_id && item.tencent_vod_app_id) {
        this.videoInfo = item,
          this.videoShow = true
      }
    },
    toMoreList(ind) {
      this.goAppsDetailsBeforeLogin().then(() => {
        let routeUrl = this.$router.resolve({
          path: `/${this.school_code}/kjqg/kcjsgm?ind=${ind}`,
        });
        window.open(routeUrl.href, "_blank");
      });

    },
    textWheel(e) {
      console.log(e);
      e.stopPropagation()
    }
  }
}
</script>

<style lang="less" scoped>
.slide-content {
  padding-top: 5.16vw;
  background-size: cover;
  background-position: center;
  height: 100%;
  position: relative;
  .resize-body {
    position: relative;
    width: 100%;
    height: 100%;
    .resize-content {
      // height: 100%;
      width: 1920px;
      transform-origin: center center;
      height: 981px;
      position: absolute;
      top: 50%;
      left: 50%;
      // transform: translateX(-50%);
      .title-content {
        // margin: 0 auto;
        text-align: center;
        .zcqd-title {
          max-width: 580px;
          margin-top: 31px;
        }
      }
      .kcjs-info {
        display: flex;
        justify-content: center;
        margin-top: 62px;
        .kcjs-cover {
          width: 488px;
          height: 663px;
          background-image: url("../../../assets/image/kjqg/index/kcjs/kcjs-cover.png");
          background-size: cover;
          background-position: center;
          cursor: pointer;
        }
        .kcjs-swiper {
          width: 850px;
          height: 663px;
          padding-top: 102px;
          margin-left: 62px;
          position: relative;
          .dggx-title {
            width: 186px;
            height: 34px;
            background-image: url("../../../assets/image/kjqg/index/kcjs/dggx-title.png");
            background-size: cover;
            position: absolute;
            top: 26px;
            left: 0;
          }
          .swiper-container {
            .swiper-slide {
              display: flex;
              .kcjs-item {
                cursor: pointer;
                width: 266px;
                height: 560px;
                .item-cover {
                  height: 342px;
                  overflow: hidden;

                  div {
                    width: 100%;
                    height: 100%;
                    background-size: cover;
                    background-position: center;
                  }
                }
                .item-info {
                  height: 218px;
                  background-color: #fff;
                  padding: 18px 20px 0;
                  display: flex;
                  flex-direction: column;
                  .info-title {
                    font-weight: bold;
                    font-size: 20px;
                    color: #273c5c;
                    letter-spacing: 5px;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    white-space: nowrap;
                    &::after {
                      content: "";
                      display: block;
                      width: 224px;
                      height: 9px;
                      background-image: url("../../../assets/image/kjqg/index/kcjs/kcjs-item-split.png");
                      background-size: cover;
                      margin-top: 5px;
                    }
                  }
                  .info-text {
                    flex: 1;
                    margin-top: 10px;
                    font-weight: 400;
                    font-size: 16px;
                    color: #494d53;
                    line-height: 28px;
                    overflow: auto;
                    padding-right: 6px;
                  }
                }
              }
            }
          }
          .swiper-button-next.kcjs {
            width: 50px;
            height: 50px;
            background-image: url("../../../assets/image/kjqg/index/kcjs/kcjs-swiper-next-btn.png");
            background-size: cover;
            right: 0;
            top: 18px;
            margin: 0;
            opacity: 1;
            &:hover {
              background-image: url("../../../assets/image/kjqg/index/kcjs/kcjs-swiper-next-btn-hover.png");
            }
          }
          .swiper-button-prev.kcjs {
            width: 50px;
            height: 50px;
            background-image: url("../../../assets/image/kjqg/index/kcjs/kcjs-swiper-prve-btn.png");
            background-size: cover;
            right: 83px;
            left: unset;
            top: 18px;
            margin: 0;
            opacity: 1;
            &:hover {
              background-image: url("../../../assets/image/kjqg/index/kcjs/kcjs-swiper-prve-btn-hover.png");
            }
          }
          .swiper-pagination.kcjs {
            position: absolute;
            top: 33px;
            right: 173px;
            margin: 0;
            /deep/.swiper-pagination-bullet {
              width: 8px;
              height: 8px;
              background: #87abff;
              border-radius: 50%;
              margin: 0 4px;
              &.swiper-pagination-bullet-active {
                width: 24px;
                height: 8px;
                background: linear-gradient(90deg, #047bfd 0%, #1952da 100%);
                border-radius: 3px;
              }
            }
          }
        }
      }
      .more {
        width: 148px;
        height: 47px;
        line-height: 47px;

        background-image: url("../../../assets/image/kjqg/index/xskj/more.png");
        background-size: cover;
        font-weight: 400;
        font-size: 16px;
        color: #0c6aef;
        text-align: center;
        cursor: pointer;
        margin: 60px auto 0;
      }
    }
  }
}
</style>